import dynamic from 'next/dynamic'

export const DynamicCMSPromotionTermsDrawer = dynamic(
  () => import('.').then((mod) => mod.CMSPromotionTermsDrawer),
  { ssr: false },
)
